import React, {useState, useEffect} from "react";

export default function GiletPrimoKnopfenFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M403.453,217.518l-0.036-0.212l-0.176-0.094c-0.082-0.035-7.632-4.174-13.548-41.247
 c-4.705-29.557,3.457-65.382,7.845-84.625c1.211-5.317,2.081-9.152,2.269-11.091c0.823-8.703-1.011-9.998-1.259-10.127
 c-0.281-0.129-28.533-12.468-50.163-19.618c-20.465-6.752-44.812-18.843-47.023-19.948l-0.012-0.119
 c-51.022,8.892-96.034,0.094-96.481,0l-0.117-0.023l-0.107,0.047c-0.293,0.118-31.027,12.89-52.703,20.042
 c-21.642,7.15-49.893,19.489-50.198,19.629c-0.224,0.118-2.059,1.412-1.236,10.116c0.189,1.939,1.06,5.774,2.27,11.079
 c4.387,19.254,12.561,55.079,7.845,84.636c-5.905,37.073-13.466,41.213-13.538,41.247l-0.188,0.094l-0.024,0.212
 c-0.012,0.083-1,8.151-0.587,14.407c1.023,15.714,1.611,31.734,2.176,47.224c0.4,11.021,0.811,22.429,1.387,33.626
 c1.434,28.216,3.105,53.834,5.093,78.321c1.106,13.49,2.318,26.816,3.61,39.578c0.718,7.115,1.389,13.408,2.048,19.265
 c0.082,0.695,0.129,1.671,0.175,2.811c0.153,3.918,0.377,9.292,2.482,10.963c0.788,0.623,1.788,0.846,2.599,1.023
 c8.492,1.916,16.937,3.34,25.099,4.235c7.469,0.823,15.185,1.234,23.559,1.234c5.598,0,11.503-0.188,17.806-0.552
 c12.927-0.741,26.358-2.318,42.307-4.974c1.083-0.202,2.153-0.4,3.234-0.612c5.117-1.024,11.08-2.458,16.491-5.387
 c5.292-2.87,8.667-6.329,12.291-10.916c2.705,3.177,5.798,6.163,9.232,8.858c9.057,7.068,21.994,11.232,38.461,12.361
 c6.857,0.47,14.831,0.73,23.241,0.73c19.348,0,41.025-1.4,56.879-4.975c0.812-0.176,1.823-0.4,2.599-1.023
 c2.105-1.671,2.329-7.045,2.494-10.974c0.047-1.129,0.082-2.104,0.164-2.8c0.659-5.857,1.342-12.15,2.058-19.265
 c1.295-12.772,2.507-26.087,3.6-39.578c1.988-24.523,3.657-50.14,5.104-78.321c0.564-11.197,0.988-22.605,1.388-33.626
 c0.565-15.49,1.141-31.51,2.176-47.224C404.441,225.669,403.464,217.601,403.453,217.518z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M117.929,180.669c-1.024,8.833-2.21,17.407-5.446,25.099c-5.962,14.185-13.384,22.524-15.501,24.735
 c-0.176-5.387,0.494-11.55,0.624-12.69c1.282-0.836,8.221-6.857,13.773-41.718c4.739-29.7-3.447-65.619-7.845-84.92
 c-1.211-5.281-2.081-9.092-2.258-10.986c-0.766-8.079,0.823-9.362,0.799-9.362c0.093-0.036,2.659-1.152,6.787-2.893
 c-1.623,6.434-0.012,13.666,0.059,13.96c1.47,7.776,2.988,15.89,4.492,24.111c0.483,2.636,0.989,5.27,1.506,7.905l0.07,0.4
 c2.047,10.608,4.152,21.581,4.599,32.861C119.975,156.924,119.446,167.566,117.929,180.669"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M256.139,447.188c-3.599,4.574-6.927,7.997-12.15,10.821c-5.328,2.893-11.209,4.304-16.277,5.316
 c-1.071,0.211-2.141,0.413-3.211,0.611c-15.914,2.647-29.323,4.223-42.213,4.964c-15.714,0.906-28.817,0.694-41.247-0.67
 c-8.139-0.906-16.549-2.318-25.006-4.222c-0.941-0.212-1.694-0.412-2.293-0.882c-1.493-1.176-1.917-4.964-2.105-8.245
 c8.08,1.718,24.888,4.799,31.651,5.54c7.233,0.799,14.643,1.176,22.654,1.176c5.432,0,11.078-0.165,17.289-0.529
 c12.561-0.718,25.676-2.27,41.296-4.87c1.022-0.175,2.046-0.364,3.045-0.564c4.493-0.895,9.68-2.14,14.091-4.529l0.151-0.082
 c2.236-1.199,5.929-3.2,10.657-8.773C253.588,443.93,254.81,445.577,256.139,447.188"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M403.336,230.504c-2.117-2.21-9.526-10.538-15.502-24.735c-3.234-7.692-4.422-16.266-5.445-25.099
 c-1.517-13.103-2.047-23.735-1.658-33.497c0.446-11.303,2.658-22.759,4.598-32.861l0.141-0.73c0.495-2.529,0.977-5.045,1.435-7.575
 c1.505-8.209,3.022-16.324,4.493-24.087c0.069-0.318,1.693-7.563,0.058-13.996c4.106,1.74,6.669,2.857,6.739,2.881
 c0.012,0.012,1.623,1.245,0.847,9.385c-0.176,1.894-1.047,5.705-2.247,10.986c-4.398,19.301-12.597,55.22-7.857,84.92
 c5.563,34.861,12.502,40.882,13.773,41.718C402.842,218.954,403.525,225.117,403.336,230.504"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M388.67,455.198c-0.2,3.211-0.647,6.786-2.082,7.927c-0.6,0.47-1.364,0.671-2.293,0.882
 c-22.688,5.104-57.326,5.763-79.909,4.222c-16.302-1.117-29.098-5.222-38.036-12.208c-9.469-7.399-16.408-17.102-19.055-26.628
 c-1.987-7.152-2.058-14.891-2.129-22.383c-0.024-2.659-0.047-5.41-0.164-8.08c-0.306-7.28-0.271-24.723-0.235-41.577
 c0.035-16.842,0.069-34.273-0.236-41.554c-0.01-1.059-1.163-106.372,0.471-135.834c0.458-8.268,1.823-16.631,3.14-24.723
 c0.4-2.435,0.789-4.869,1.165-7.303c1.705-11.115,11.385-28.181,20.735-44.682c3.811-6.728,7.751-13.68,11.15-20.207
 c6.776-13.009,12.551-29.393,17.655-43.848c0.917-2.622,1.835-5.187,2.717-7.68c0.941,0.47,2.765,1.364,5.234,2.54
 c-0.624,2.176-3.069,8.657-3.105,8.727c-4.763,13.538-10.703,30.38-17.736,43.883c-3.528,6.774-7.656,14.066-11.315,20.5
 c-8.574,15.127-18.302,32.286-19.784,41.966c-0.34,2.258-0.716,4.516-1.082,6.787l-0.095,0.588
 c-1.282,7.834-2.598,15.926-3.045,23.887c-1.565,28.075-0.589,124.309-0.47,135.2c0.294,7.257,0.27,23.876,0.247,39.942v1.846
 c-0.035,16.76-0.07,34.097,0.235,41.201c0.118,2.775,0.141,5.611,0.165,8.363c0.058,6.963,0.117,14.149,1.835,20.348
 c2.21,7.939,8.162,16.16,16.336,22.546c7.669,5.987,19.019,9.539,33.733,10.55c6.845,0.47,14.69,0.718,22.676,0.718
 C344.847,461.114,374.592,458.009,388.67,455.198"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M254.199,131.259c-0.941,2.047-1.787,4.01-2.529,5.916c-33.24-32.874-48.787-85.353-53.975-103.032
 c3.035-1.235,5.292-2.164,6.434-2.635C205.588,37.732,218.868,90.717,254.199,131.259"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M300.834,31.309c-0.835,2.341-1.693,4.752-2.563,7.21l-0.059-0.577c-14.326,1.695-34.897,3.682-45.742,3.682
 c-13.608,0-32.239-2.305-42.236-3.552c-1.341-0.164-2.552-0.317-3.587-0.435l-0.036,0.341c-0.976-3.446-1.552-5.799-1.776-6.751
 C207.47,31.721,251.246,39.813,300.834,31.309"
      />
      <path
        fill={darkenColor}
        d="M274.333,40.781l-23.11,1.632l-15.037-0.757c-9.857-0.777-19.713-2-26.088-2.788
 c-1.27-0.165-2.411-0.306-3.411-0.423c4.812,16.948,18.842,58.691,47.823,92.081c3.94-8.409,9.291-17.865,14.831-27.615
 c3.811-6.716,7.739-13.668,11.137-20.184c6.74-12.961,12.515-29.322,17.608-43.742c0.023-0.082,0.047-0.165,0.083-0.235
 L274.333,40.781z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M265.76,47.693c-0.446,0.212-1.564,0.718-3.222,1.271c-0.176-1.647-0.318-5.752-0.365-6.916
 c1.094-0.059,2.223-0.129,3.376-0.212C265.561,43.011,265.607,45.858,265.76,47.693"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M240.356,41.929c-0.023,0.941-0.177,5.305-0.365,7.034c-1.658-0.552-2.775-1.059-3.223-1.271
 c0.165-1.929,0.212-4.951,0.224-6.01C238.121,41.776,239.239,41.859,240.356,41.929"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M265.891,48.834c-0.177,0.611-2.223,3.845-2.917,4.139c-1.329,0.565-6.034,1.988-11.656,1.882h-0.694
 c-5.387,0-9.785-1.34-11.055-1.882c-0.706-0.294-2.752-3.528-2.929-4.139c0.023-0.095,0.036-0.212,0.046-0.329
 c1.623,0.74,7.175,3.011,14.526,3.14v0.012h0.106v-0.012c7.363-0.129,12.902-2.399,14.526-3.14
 C265.855,48.622,265.878,48.74,265.891,48.834"
      />
      <path
        fill="#010101"
        d="M264.762,159.251c-2.999,0-5.447,2.447-5.447,5.434c0,2.999,2.448,5.446,5.447,5.446
 c2.987,0,5.433-2.447,5.433-5.446C270.195,161.698,267.749,159.251,264.762,159.251 M264.762,169.355
 c-2.588,0-4.681-2.094-4.681-4.67s2.093-4.67,4.681-4.67c2.563,0,4.669,2.094,4.669,4.67S267.325,169.355,264.762,169.355"
      />
      <path
        fill="#010101"
        d="M265.102,248.253c-2.999,0-5.434,2.434-5.434,5.433c0,2.999,2.435,5.434,5.434,5.434
 s5.434-2.435,5.434-5.434C270.536,250.687,268.101,248.253,265.102,248.253 M265.102,258.356c-2.576,0-4.669-2.094-4.669-4.67
 c0-2.575,2.093-4.67,4.669-4.67s4.669,2.095,4.669,4.67C269.771,256.262,267.678,258.356,265.102,258.356"
      />
      <path
        fill="#010101"
        d="M266.09,334.794c-2.998,0-5.434,2.435-5.434,5.434s2.436,5.434,5.434,5.434c2.989,0,5.434-2.435,5.434-5.434
 S269.078,334.794,266.09,334.794 M266.09,344.898c-2.575,0-4.669-2.094-4.669-4.67s2.094-4.67,4.669-4.67
 c2.576,0,4.67,2.094,4.67,4.67S268.665,344.898,266.09,344.898"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.3389,1.3378"
        d="
 M98.224,227.164c3.299-4.112,8.214-11.208,12.437-21.244c3.32-7.894,4.499-16.768,5.475-25.209c1.286-11.129,2.1-22.344,1.658-33.55
 c-0.438-11.116-2.508-22.026-4.607-32.926c-0.532-2.764-1.067-5.528-1.575-8.296c-1.475-8.041-2.973-16.077-4.492-24.109
 c0,0-1.42-6.171-0.421-12.144"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.3389,1.3378"
        d="
 M402.098,227.164c-3.299-4.112-8.214-11.208-12.437-21.244c-3.32-7.894-4.499-16.768-5.475-25.209
 c-1.286-11.129-2.1-22.344-1.658-33.55c0.438-11.116,2.508-22.026,4.607-32.926c0.532-2.764,1.067-5.528,1.575-8.296
 c1.476-8.041,2.973-16.077,4.493-24.109c0,0,1.42-6.171,0.42-12.144"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.3389,1.3378"
        d="
 M386.843,457.433c-13.372,2.735-43.372,6.003-63.684,6.003c-7.982,0-15.813-0.249-22.647-0.718
 c-14.641-1.003-25.922-5.702-33.533-11.648c-8.109-6.336-14.014-16.011-16.202-23.875c-1.704-6.142-1.762-13.311-1.818-20.243
 c-0.023-2.784-0.048-5.594-0.172-8.381c-0.297-7.092-0.261-24.422-0.227-41.182l0.002-1.611c0.023-16.172,0.048-32.891-0.252-40.2
 c-0.062-5.884-1.123-106.597,0.473-135.16c0.44-7.932,1.759-16.022,3.035-23.844l0.097-0.595c0.371-2.268,0.739-4.528,1.09-6.787
 c1.466-9.611,11.174-26.733,19.738-41.84c3.664-6.456,7.793-13.731,11.317-20.509c6.894-13.239,12.665-29.468,17.763-43.925
 c0,0,2.731-7.216,3.199-9.055"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.3389,1.3378"
        d="
 M252.508,444.085c-4.965,5.965-8.867,7.987-11.034,9.159c-4.368,2.364-9.518,3.593-13.978,4.486
 c-0.995,0.196-2.019,0.385-3.035,0.564c-15.583,2.594-28.718,4.144-41.259,4.865c-6.191,0.356-11.836,0.53-17.257,0.53
 c-8.002,0-15.4-0.385-22.62-1.176c-7.122-0.784-24.666-4.043-32.097-5.642"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.3389,1.3378"
        d="
 M199.255,33.917c5.27,17.941,18.754,67.703,52.553,100.818"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.3389,1.3378"
        d="
 M206.603,35.778c8.954,1.077,30.457,3.992,45.865,3.992h0.007c11.964,0,34.471-2.342,45.778-3.681"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.2276,1.2265"
        d="
 M292.757,250.744c-0.02,0-0.072,0-0.133-0.061c-0.038-0.038-0.099-0.121-0.099-0.264l0.316-94.956l5.449,0.015
 c16.372,0,55.567,0.029,65.888,0.299c-0.001,0.002,0.046,0.04,0.044,0.134l-1.783,94.647c-0.002,0.101-0.06,0.144-0.071,0.148
 l-69.609,0.038H292.757z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.1982,1.1961"
        d="
 M293.342,166.246c0,0,32.141,1.098,70.105-0.229"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.2013,1.2003"
        d="
 M293.409,170.166c0,0,32.11,1.031,70.037-0.405"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.5174,1.5163"
        d="
 M127.223,436.156c-0.578,0-1.016-0.005-1.348-0.009c-3.32-7.816-7.344-66.596-9.765-119.713c11.596-0.44,76.509-2.885,90.123-2.959
 l3.834,120.494C198.617,434.268,140.464,436.156,127.223,436.156z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.5016,1.5006"
        d="
 M117.841,330.834c0,0,39.857,0.105,87.873-3.258"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.5016,1.5006"
        d="
 M117.467,335.767c0,0,39.858,0.105,87.873-3.258"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.5174,1.5163"
        d="
 M371.466,435.699c-17.899,0-69.321-0.997-79.447-1.197l2.328-120.457c0.426-0.003,0.904-0.004,1.428-0.004
 c15.987,0,74.525,1.431,88.727,1.784c-1.727,53.146-4.983,111.976-8.198,119.829C375.483,435.678,374.032,435.699,371.466,435.699z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.4974,1.4953"
        d="
 M382.299,330.304c0,0-39.62,0.606-87.398-2.152"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.4725"
        strokeMiterlimit="10"
        strokeDasharray="1.4974,1.4953"
        d="
 M382.738,335.232c0,0-39.62,0.606-87.398-2.152"
      />
      <path
        fill="#010101"
        d="M364.252,153.043c-11.479-0.295-57.643-0.295-71.51-0.295c-1.447,0-2.635,1.212-2.635,2.705l-0.318,94.964
 c0,0.835,0.318,1.611,0.895,2.2c0.565,0.552,1.294,0.858,2.071,0.858l69.617-0.035c1.516,0,2.775-1.271,2.799-2.834l1.787-94.647
 C366.981,154.395,365.77,153.089,364.252,153.043 M364.405,250.593c-0.012,1.153-0.929,2.081-2.034,2.081l-69.617,0.036
 c-0.576,0-1.118-0.224-1.529-0.635c-0.436-0.435-0.671-1.023-0.671-1.658l0.318-94.964c0-1.07,0.835-1.939,1.869-1.939
 c13.867-0.013,60.019,0,71.487,0.293c1.106,0.036,1.988,0.988,1.964,2.141L364.405,250.593z"
      />
      <path
        fill="#010101"
        d="M386.799,313.647c-0.317-0.33-0.741-0.518-1.199-0.529c-13.208-0.33-79.708-1.964-91.941-1.8
 c-1.117,0.013-2.012,0.906-2.034,2.035l-2.27,121.18c-0.024,1.458,1.14,2.669,2.611,2.705c11.385,0.224,61.665,1.199,79.497,1.199
 c3.105,0,5.234-0.036,5.998-0.106c1.012-0.082,3.717-0.33,6.928-57.056c1.646-29.204,2.692-60.432,2.881-66.394
 C387.281,314.423,387.117,313.988,386.799,313.647 M383.624,381.228c-2.94,52.034-5.516,56.281-6.234,56.35
 c-5.116,0.447-72.039-0.846-85.411-1.106c-1.047-0.023-1.871-0.893-1.86-1.929l2.27-121.179c0.013-0.706,0.577-1.271,1.282-1.282
 c0.577-0.012,1.271-0.012,2.081-0.012c16.796,0,82.109,1.612,89.836,1.811c0.247,0,0.482,0.106,0.658,0.294
 c0.176,0.188,0.271,0.423,0.258,0.683C386.317,320.822,385.27,352.036,383.624,381.228"
      />
      <path
        fill="#010101"
        d="M208.953,312.753c-0.047-1.13-0.953-2.012-2.071-2.012h-0.059c-12.679,0-83.778,2.693-91.846,2.999
 c-0.459,0.024-0.894,0.212-1.199,0.552c-0.306,0.342-0.471,0.777-0.447,1.236c0.271,5.951,1.718,37.108,3.752,66.347
 c3.951,56.679,6.657,56.892,7.669,56.962c0.423,0.035,1.258,0.047,2.446,0.047c13.291,0,70.758-1.859,83.037-2.259
 c1.46-0.046,2.612-1.282,2.565-2.741L208.953,312.753z M210.199,435.862c-13.361,0.435-80.285,2.622-85.389,2.223
 c-0.718-0.059-3.34-4.281-6.963-56.256c-2.035-29.227-3.482-60.383-3.753-66.335c-0.01-0.258,0.071-0.495,0.248-0.682
 c0.176-0.189,0.412-0.295,0.659-0.306c8.079-0.307,79.166-3,91.822-3c0.776-0.012,1.329,0.541,1.353,1.271l3.858,121.133
 C212.069,434.944,211.246,435.827,210.199,435.862"
      />
      <path
        fill="#010101"
        d="M403.454,217.531l-0.036-0.212l-0.176-0.094c-0.082-0.035-7.632-4.174-13.548-41.248
 c-4.705-29.557,3.457-65.382,7.845-84.625c1.211-5.317,2.081-9.152,2.269-11.091c0.823-8.703-1.011-9.998-1.259-10.127
 c-0.281-0.129-28.533-12.468-50.163-19.618c-20.465-6.752-44.812-18.843-47.023-19.947l-0.012-0.119
 c-51.022,8.892-96.034,0.095-96.481,0l-0.117-0.023l-0.107,0.047c-0.293,0.118-31.027,12.89-52.703,20.042
 c-21.642,7.15-49.893,19.489-50.198,19.629c-0.224,0.118-2.059,1.412-1.236,10.116c0.189,1.939,1.06,5.774,2.27,11.079
 c4.387,19.254,12.561,55.079,7.845,84.636c-5.905,37.073-13.466,41.213-13.538,41.248l-0.188,0.094l-0.024,0.212
 c-0.012,0.083-1,8.151-0.587,14.407c1.023,15.714,1.611,31.734,2.176,47.224c0.4,11.021,0.811,22.429,1.387,33.626
 c1.434,28.216,3.105,53.834,5.093,78.321c1.106,13.491,2.318,26.816,3.61,39.578c0.718,7.115,1.389,13.408,2.048,19.265
 c0.082,0.695,0.129,1.671,0.175,2.811c0.153,3.918,0.377,9.292,2.482,10.963c0.788,0.623,1.788,0.846,2.599,1.023
 c8.492,1.916,16.937,3.34,25.099,4.235c7.469,0.823,15.185,1.234,23.559,1.234c5.598,0,11.503-0.188,17.806-0.552
 c12.927-0.741,26.358-2.318,42.307-4.974c1.083-0.202,2.153-0.4,3.234-0.612c5.117-1.024,11.08-2.458,16.491-5.387
 c5.292-2.87,8.667-6.329,12.291-10.916c2.705,3.177,5.798,6.163,9.232,8.858c9.057,7.068,21.994,11.232,38.461,12.361
 c6.857,0.47,14.831,0.73,23.241,0.73c19.348,0,41.025-1.4,56.879-4.975c0.812-0.176,1.823-0.4,2.599-1.023
 c2.105-1.671,2.329-7.045,2.494-10.974c0.047-1.129,0.082-2.104,0.164-2.8c0.659-5.857,1.342-12.15,2.058-19.265
 c1.295-12.772,2.507-26.087,3.6-39.578c1.988-24.523,3.657-50.14,5.104-78.321c0.564-11.197,0.988-22.605,1.388-33.626
 c0.565-15.49,1.141-31.51,2.176-47.224C404.442,225.682,403.466,217.614,403.454,217.531 M300.834,31.309
 c-0.835,2.341-1.694,4.752-2.564,7.21l-0.058-0.577c-14.326,1.694-34.898,3.682-45.742,3.682c-13.608,0-32.239-2.305-42.237-3.552
 c-1.34-0.164-2.551-0.318-3.587-0.435l-0.035,0.34c-0.977-3.445-1.552-5.798-1.776-6.75
 C207.471,31.721,251.247,39.813,300.834,31.309 M239.262,53.679c0.047,0.024,4.669,1.953,11.291,1.953c0.236,0,0.47,0,0.718-0.012
 c0.235,0.012,0.47,0.012,0.705,0.012c6.634,0,11.244-1.929,11.292-1.953c0.988-0.423,3.388-4.174,3.388-4.915
 c-0.247-1.342-0.33-5.552-0.341-6.975c10.291-0.717,22.441-1.952,31.899-3.07c-0.037,0.071-0.06,0.153-0.083,0.235
 c-5.093,14.42-10.868,30.78-17.608,43.741c-3.398,6.516-7.328,13.467-11.137,20.184c-5.54,9.75-10.893,19.206-14.831,27.616
 c-28.981-33.392-43.012-75.134-47.823-92.082c1,0.119,2.141,0.258,3.411,0.424c6.375,0.788,16.231,2.011,26.087,2.787
 c-0.023,1.246-0.094,5.751-0.353,7.21C235.875,49.481,238.274,53.256,239.262,53.679 M251.212,51.645v0.012h0.105v-0.012
 c7.363-0.129,12.904-2.399,14.526-3.14c0.012,0.117,0.036,0.234,0.047,0.329c-0.177,0.611-2.223,3.845-2.917,4.139
 c-1.329,0.566-6.034,1.988-11.656,1.882h-0.694c-5.387,0-9.785-1.34-11.055-1.882c-0.706-0.294-2.752-3.528-2.929-4.139
 c0.023-0.095,0.036-0.212,0.047-0.329C238.31,49.246,243.86,51.516,251.212,51.645 M236.768,47.692
 c0.165-1.929,0.212-4.951,0.224-6.01c1.129,0.093,2.246,0.176,3.365,0.247c-0.024,0.941-0.177,5.305-0.365,7.033
 C238.333,48.411,237.215,47.905,236.768,47.692 M240.731,49.198c0.201-1.658,0.354-6.175,0.389-7.221
 c3.964,0.258,7.822,0.411,11.35,0.411c2.529,0,5.575-0.105,8.939-0.293c0.047,1.235,0.2,5.504,0.388,7.104
 c-2.599,0.799-6.257,1.612-10.526,1.694C246.989,50.81,243.331,49.997,240.731,49.198 M262.173,42.047
 c1.094-0.058,2.224-0.129,3.376-0.212c0.012,1.176,0.059,4.023,0.211,5.857c-0.445,0.212-1.564,0.718-3.222,1.271
 C262.362,47.317,262.22,43.212,262.173,42.047 M204.13,31.509c1.459,6.223,14.737,59.208,50.069,99.75
 c-0.942,2.047-1.788,4.011-2.53,5.916c-33.238-32.874-48.787-85.353-53.974-103.032C200.731,32.908,202.989,31.979,204.13,31.509
  M97.605,217.813c1.282-0.836,8.221-6.857,13.773-41.718c4.739-29.7-3.446-65.619-7.845-84.92
 c-1.211-5.281-2.081-9.092-2.258-10.986c-0.765-8.079,0.823-9.362,0.799-9.362c0.093-0.036,2.659-1.152,6.787-2.893
 c-1.623,6.434-0.012,13.666,0.059,13.96c1.47,7.776,2.987,15.89,4.492,24.111c0.483,2.636,0.989,5.27,1.506,7.905l0.07,0.4
 c2.047,10.608,4.152,21.581,4.599,32.861c0.387,9.751-0.142,20.394-1.659,33.497c-1.024,8.833-2.21,17.407-5.445,25.099
 c-5.963,14.185-13.385,22.524-15.502,24.735C96.805,225.117,97.476,218.954,97.605,217.813 M111.53,452.728
 c-0.047-1.153-0.082-2.14-0.165-2.858c-0.658-5.857-1.34-12.15-2.058-19.254c-1.293-12.772-2.506-26.075-3.599-39.564
 c-1.988-24.477-3.657-50.093-5.092-78.298c-0.577-11.197-0.989-22.594-1.389-33.626c-0.565-15.491-1.152-31.522-2.176-47.235
 c-0.012-0.118-0.012-0.235-0.023-0.341c1.129-1.117,9.55-9.774,16.16-25.487c3.282-7.786,4.47-16.42,5.506-25.311
 c1.516-13.139,2.047-23.818,1.658-33.604c-0.447-11.349-2.564-22.346-4.611-32.991l-0.082-0.389
 c-0.506-2.635-1.012-5.269-1.494-7.903c-1.506-8.221-3.022-16.337-4.492-24.124c-0.024-0.082-1.753-7.811,0.082-14.185
 c9.926-4.187,27.711-11.455,42.424-16.313c15.161-5.01,34.239-12.537,44.8-16.819c5.246,17.843,20.889,70.57,54.386,103.525
 c-1.376,3.6-2.365,6.916-2.81,9.869c-0.377,2.434-0.777,4.869-1.166,7.304c-1.328,8.104-2.692,16.49-3.152,24.793
 c-1.634,29.499-0.482,134.835-0.469,135.906c0.198,4.952,0.258,14.62,0.258,25.594h-0.036v0.387h0.036
 c0,5.022-0.013,10.315-0.023,15.55c-0.037,16.865-0.071,34.309,0.247,41.612c0.106,2.646,0.129,5.398,0.152,8.057
 c0.071,7.527,0.141,15.325,2.153,22.582c1.118,4.023,2.999,8.068,5.493,11.962c-4.716,5.611-8.387,7.597-10.598,8.785l-0.153,0.083
 c-4.328,2.341-9.444,3.564-13.878,4.446c-0.988,0.2-2.011,0.388-3.022,0.565c-15.584,2.599-28.688,4.139-41.213,4.869
 c-6.187,0.353-11.833,0.517-17.242,0.517c-7.987,0-15.361-0.376-22.571-1.165c-6.799-0.752-23.782-3.868-31.768-5.575
 C111.578,453.61,111.554,453.151,111.53,452.728 M243.99,458.009c-5.327,2.893-11.209,4.305-16.277,5.317
 c-1.071,0.211-2.141,0.412-3.211,0.611c-15.914,2.646-29.323,4.222-42.213,4.963c-15.714,0.907-28.816,0.695-41.248-0.669
 c-8.139-0.907-16.549-2.318-25.006-4.223c-0.941-0.211-1.694-0.411-2.293-0.882c-1.493-1.176-1.916-4.963-2.105-8.244
 c8.08,1.718,24.888,4.798,31.651,5.539c7.233,0.8,14.643,1.176,22.654,1.176c5.433,0,11.08-0.164,17.29-0.529
 c12.56-0.717,25.675-2.27,41.295-4.869c1.022-0.175,2.046-0.364,3.045-0.564c4.493-0.895,9.68-2.14,14.091-4.529l0.152-0.082
 c2.236-1.2,5.928-3.2,10.656-8.773c1.118,1.681,2.341,3.328,3.669,4.94C252.54,451.763,249.213,455.186,243.99,458.009
  M386.588,463.125c-0.6,0.471-1.364,0.671-2.293,0.882c-22.688,5.106-57.326,5.764-79.908,4.223
 c-16.303-1.118-29.098-5.223-38.037-12.208c-9.469-7.399-16.408-17.102-19.055-26.629c-1.987-7.151-2.058-14.89-2.129-22.382
 c-0.023-2.659-0.047-5.41-0.164-8.08c-0.306-7.28-0.271-24.723-0.235-41.577c0.035-16.842,0.07-34.274-0.235-41.554
 c-0.012-1.059-1.165-106.372,0.47-135.835c0.458-8.268,1.823-16.631,3.14-24.723c0.4-2.434,0.789-4.869,1.165-7.303
 c1.705-11.115,11.385-28.181,20.735-44.682c3.811-6.728,7.751-13.678,11.151-20.207c6.775-13.009,12.55-29.392,17.654-43.848
 c0.917-2.622,1.835-5.186,2.717-7.679c0.942,0.47,2.765,1.364,5.234,2.54c-0.623,2.176-3.068,8.657-3.105,8.726
 c-4.763,13.539-10.703,30.381-17.736,43.883c-3.528,6.774-7.656,14.067-11.315,20.501c-8.574,15.125-18.301,32.286-19.783,41.966
 c-0.341,2.258-0.717,4.515-1.083,6.787l-0.095,0.587c-1.281,7.834-2.598,15.926-3.045,23.887c-1.565,28.075-0.589,124.31-0.47,135.2
 c0.294,7.257,0.271,23.876,0.247,39.942v1.847c-0.035,16.76-0.07,34.097,0.235,41.2c0.118,2.776,0.142,5.611,0.165,8.363
 c0.059,6.963,0.117,14.15,1.835,20.348c2.211,7.94,8.162,16.161,16.337,22.548c7.668,5.987,19.018,9.539,33.732,10.55
 c6.844,0.47,14.69,0.717,22.676,0.717c19.455,0,49.2-3.105,63.278-5.915C388.47,458.409,388.023,461.983,386.588,463.125
  M403.278,231.892c-1.035,15.714-1.612,31.744-2.176,47.235c-0.4,11.032-0.823,22.429-1.388,33.626
 c-1.446,28.169-3.117,53.774-5.104,78.298c-1.094,13.478-2.305,26.792-3.599,39.564c-0.717,7.105-1.388,13.397-2.058,19.254
 c-0.082,0.718-0.119,1.705-0.165,2.847c-0.024,0.529-0.047,1.106-0.083,1.694c-13.949,2.81-43.812,5.939-63.313,5.939
 c-7.973,0-15.795-0.248-22.618-0.718c-14.559-0.999-25.769-4.492-33.319-10.384c-8.057-6.293-13.902-14.361-16.079-22.159
 c-1.681-6.093-1.74-13.232-1.799-20.16c-0.024-2.741-0.046-5.588-0.176-8.374c-0.295-7.08-0.259-24.405-0.224-41.166v-1.847
 c0.023-16.077,0.047-32.697-0.248-39.965c-0.046-4.34-1.129-106.596,0.471-135.141c0.435-7.916,1.752-15.983,3.034-23.794l0.095-0.6
 c0.365-2.269,0.741-4.528,1.094-6.787c1.447-9.551,11.137-26.64,19.689-41.718c3.646-6.434,7.798-13.726,11.326-20.512
 c7.045-13.549,12.996-30.427,17.772-43.965c0.106-0.281,2.399-6.351,3.092-8.656c9.069,4.305,25.864,11.962,40.637,16.842
 c14.725,4.858,32.52,12.138,42.436,16.313c1.823,6.374,0.093,14.103,0.069,14.197c-1.469,7.785-2.975,15.9-4.492,24.111
 c-0.459,2.529-0.941,5.045-1.434,7.563l-0.13,0.729c-1.965,10.138-4.175,21.63-4.622,32.991c-0.387,9.786,0.142,20.465,1.658,33.604
 c1.036,8.891,2.223,17.525,5.505,25.311c6.61,15.712,15.032,24.369,16.161,25.487C403.289,231.657,403.278,231.774,403.278,231.892
  M403.336,230.504c-2.117-2.21-9.526-10.538-15.502-24.735c-3.234-7.692-4.422-16.266-5.445-25.099
 c-1.517-13.103-2.047-23.735-1.658-33.497c0.446-11.303,2.658-22.759,4.598-32.861l0.141-0.73c0.495-2.529,0.977-5.045,1.435-7.575
 c1.505-8.209,3.022-16.324,4.493-24.087c0.069-0.318,1.693-7.563,0.058-13.996c4.106,1.74,6.669,2.857,6.739,2.881
 c0.012,0.012,1.623,1.245,0.847,9.385c-0.176,1.894-1.047,5.705-2.247,10.986c-4.398,19.301-12.597,55.22-7.857,84.92
 c5.563,34.861,12.502,40.882,13.773,41.718C402.842,218.954,403.525,225.117,403.336,230.504"
      />
    </svg>
  );
}
